export default __webpack_public_path__ + "static/media/pantry1-afterG-1440w.1de4fd21.png";